/* global FB */
/* eslint no-undef: "error" */
import humps from 'humps'
import { appendScript, merge } from '../../../../../shared/utils/commonUtils'
import { generateServices } from '../../../../../shared/service'

import facebookLogin from './facebookLogin'
import facebookBindAccount from './facebookBindAccount'
import facebookCreateAccount from './facebookCreateAccount'
import { facebookServiceConfig } from '../../../config'

const init = ({ fbAppId: appId, fbVersion: version, locale }) => {
  window.fbAsyncInit = () => {
    FB.init({
      appId, status: true, cookie: true, oauth: true, xfbml: false, version,
    })
  }
  appendScript({
    src: `//connect.facebook.net/${locale}/sdk.js`,
  })
}

export default props => {
  const {
    locale, clientConfig: { fbAppId, fbVersion },
    clientId, redirectUri,
  } = props

  init({ fbAppId, fbVersion, locale })
  const defaultParams = {
    clientId,
    redirectUri,
    locale,
    jsLocale: locale,
  }
  const fbServices = generateServices(facebookServiceConfig.map(config => merge(config, {
    params: merge(defaultParams, humps.decamelizeKeys(defaultParams)),
  })), props)

  return {
    facebookLogin: facebookLogin({ ...props, fbServices }),
    facebookBindAccount: facebookBindAccount({ ...props, fbServices }),
    facebookCreateAccount: facebookCreateAccount({ ...props, fbServices }),
  }
}
